module.exports = __webpack_public_path__ + "img/1-9.af860b4d.jpg";